import { Component, effect, Inject, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DefinitionService } from '../../../../../core/services/definition/definition.service';
import { MatIconModule } from '@angular/material/icon';
import { MachineManufacturerModelsDialogInfoModel } from '../../../models/machine-manufacturer-models-dialog-info.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MachineManufacturerModelDto } from '../../../../../core/models/definitions/machine-manufacturer-model-dto';
import { MachineSize, MachineSizeLabels } from '../../../../../core/models/machines/machine-size';
import { MatSelect } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { finalize } from 'rxjs';
import { CreateMachineManufacturerModelDto } from '../../../../../core/models/definitions/definition-model-dto';
export type MachineManufacturerFormGroup = FormGroup<{
  id: FormControl<number | null>;
  shortName: FormControl<string | null>;
  name: FormControl<string | null>;
  size: FormControl<MachineSize | null>;
  isUsed: FormControl<boolean | null>;
}>
@Component({
  selector: 'app-manufacturer-models-dialog',
  imports: [MatProgressSpinnerModule, MatIconModule, MatTableModule, MatButtonModule, MatFormFieldModule, MatSelect, MatOptionModule, MatInputModule, FormsModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './manufacturer-models-dialog.component.html',
  styleUrl: './manufacturer-models-dialog.component.scss',
  standalone: true
})
export class ManufacturerModelsDialogComponent implements OnInit {
  isLoading = true;
  dataSource: MatTableDataSource<MachineManufacturerModelDto>;
  displayedColumns: string[] = ["shortName", "name", "size", "action"];

  loading = signal<boolean>(false);

  machineSizeLabels = MachineSizeLabels;
  machineSizeEnum = Object.values(MachineSize).filter(x => typeof x === "number");
  sizeGroup: FormGroup<{ size: FormControl<MachineSize>; }>;

  newItem: CreateMachineManufacturerModelDto = { name: '', shortName: '', size: MachineSize.Medium };

  modifiedRows: Set<number> = new Set();

  constructor(@Inject(MAT_DIALOG_DATA) public machineManufacturerInfo: MachineManufacturerModelsDialogInfoModel,
    public dialogRef: MatDialogRef<ManufacturerModelsDialogComponent>,
    private fb: FormBuilder,
    public definitionService: DefinitionService) {
    this.sizeGroup = new FormGroup({
      size: new FormControl()
    });

    this.dataSource = new MatTableDataSource();
    effect(() => {
      this.dataSource.data = this.definitionService.machineManufacturerModels();
      this.isLoading = false;
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadMachineManufacturerModels();
  }

  private loadMachineManufacturerModels() {
    this.definitionService.loadMachineManufacturerModels(this.machineManufacturerInfo.machineManufacturerId);
  }

  onInputChange(rowIndex: number): void {
    this.modifiedRows.add(rowIndex);
  }

  isRowModified(rowIndex: number): boolean {
    return this.modifiedRows.has(rowIndex);
  }

  isModelValueUsed(element: MachineManufacturerModelDto) {
    return element.isUsed;
  }

  saveRow(element: MachineManufacturerModelDto, rowIndex: number): void {
    this.definitionService.updateMachineManufacturerModelValue(element);
    this.modifiedRows.delete(rowIndex);
  }

  addItem() {
    if (!this.isValidNewItem()) {
      return;
    }

    this.loading.set(true);
    this.definitionService.createMachineManufacturerModel(this.machineManufacturerInfo.machineManufacturerId, this.newItem).pipe(finalize(() => {
      this.loadMachineManufacturerModels();
      this.resetNewItem();
      this.loading.set(false);
    })).subscribe();
  }

  isValidNewItem(): boolean {
    return this.newItem.name.trim() !== '' && this.newItem.shortName.trim() !== '';
  }

  private resetNewItem() {
    this.newItem = { name: '', shortName: '', size: MachineSize.Medium };
  }

  deleteRow(element: MachineManufacturerModelDto) {
    this.definitionService.deleteMachineManufacturerModelValue(element).pipe(finalize(() => {
      this.loadMachineManufacturerModels();
      this.loading.set(false);
      this.isLoading = false;
    })).subscribe();
  }

  onClose() {
    this.dialogRef.close();
  }
}